module.exports = __webpack_public_path__ + "img/miljö.36a6d3fa.jpg";